import SafeAreaView from 'react-native-safe-area-view';
import {Colors} from 'utils';
import React from 'react';

const IOSStatusBar = ({color = Colors.primary, style}) => (
  <SafeAreaView style={[{backgroundColor: color}, style]} />
);

export default IOSStatusBar;
